import React, { useRef, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Home from "./components/Home";
import Portfolio from "./components/Portfolio";
import Careers from "./components/Careers";
import Admin from "./components/Admin";
import ProjectCaseStudy from "./components/ProjectCaseStudy";
import Craft from "./components/Craft";
import FAQ from "./components/FAQ";
import NotFound from "./components/NotFound";
import LegalPage from "./components/LegalPage";
import ConsentBanner from "./components/ConsentBanner";
import privacy from "./content/legal/privacy";
import terms from "./content/legal/terms";
import aiDataPolicy from "./content/legal/aiDataPolicy";
import "./App.css";

gsap.registerPlugin(ScrollTrigger);

function CustomScrollbar() {
  const thumbRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const thumb = thumbRef.current;
    if (!thumb) return;

    const onScroll = () => {
      const scrolled = window.scrollY;
      const total = document.documentElement.scrollHeight - window.innerHeight;
      if (total <= 0) return;

      const ratio = scrolled / total;
      const thumbH = Math.max(48, (window.innerHeight / document.documentElement.scrollHeight) * window.innerHeight);
      const maxTop = window.innerHeight - thumbH;

      thumb.style.height = thumbH + "px";
      thumb.style.top = (ratio * maxTop) + "px";
      thumb.style.opacity = "1";

      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        thumb.style.opacity = "0";
      }, 1000);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed", top: 0, right: 0,
        width: "8px", height: "100vh",
        zIndex: 99999, pointerEvents: "none",
      }}
    >
      <div
        ref={thumbRef}
        style={{
          position: "absolute",
          right: "2px",
          width: "4px",
          background: "rgba(91,148,144,0.55)",
          borderRadius: "4px",
          opacity: 0,
          transition: "opacity 0.5s ease",
        }}
      />
    </div>
  );
}

function ServicesRedirect() {
  React.useEffect(() => {
    window.location.replace('/#services');
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <CustomScrollbar />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/project/:projectId" element={<ProjectCaseStudy />} />
          <Route path="/services" element={<ServicesRedirect />} />
          <Route path="/craft" element={<Craft />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy" element={<LegalPage doc={privacy} />} />
          <Route path="/terms" element={<LegalPage doc={terms} />} />
          <Route path="/ai-data-policy" element={<LegalPage doc={aiDataPolicy} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ConsentBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;